import { Resume } from '../types';

// Sample resume data - replace with actual content from PDFs
export const resumeData: Resume = {
  personalInfo: {
    name: 'Ravindra Singh Rathor',
    title: 'Senior Software Engineer',
    email: 'softwareprovider.ravindra@gmail.com',
    phone: '+91-8559973738',
    location: 'Bangalore, Karnataka, India',
    linkedin: 'https://linkedin.com/in/softwareprovider-ravindra',
    github: 'https://github.com/softwareprovider-ravindra',
    website: 'https://rathor.dev',
  },
  summary:
    'Senior Systems Engineer with deep expertise in Cloudflare Workers ecosystem, AWS, and GCP. Specialized in building scalable distributed systems, real-time communication platforms, and cloud infrastructure. Led infrastructure migrations and team development across multiple organizations.',
  experience: [
    {
      id: '1',
      company: 'Cloudflare',
      title: 'Senior Systems Engineer P4',
      duration: 'Feb 2025 - Present',
      location: 'Bangalore, Karnataka, India - Hybrid',
      description:
        'Leading infrastructure migration and platform development following Dyte\'s acquisition by Cloudflare, transitioning systems to Cloudflare\'s edge platform.',
      achievements: [
        'Key contributor to Dyte\'s acquisition integration into Cloudflare, leading the infrastructure migration from AWS to Cloudflare\'s edge platform, successfully transitioning distributed systems to Workers, R2, D1, KV, Durable Objects, and Queues',
        'Drove repository migration from GitHub to GitLab for 20+ codebases, establishing robust CI/CD pipelines and automated workflows to support the evolution of Dyte into Cloudflare RealtimeKit',
      ],
      kudos: [],
      links: [
        {
          label: 'Cloudflare',
          url: 'https://www.cloudflare.com',
        },
        {
          label: 'Cloudflare RealtimeKit',
          url: 'https://developers.cloudflare.com/realtime/realtimekit',
        },
        {
          label: 'Cloudflare RealtimeKit Demo',
          url: 'https://demo.realtime.cloudflare.com',
        },
      ],
    },
    {
      id: '2',
      company: 'Dyte.io (Acquired by Cloudflare)',
      title: 'Senior Full Stack Engineer',
      duration: 'Feb 2022 - Feb 2025',
      location: 'Bangalore, Karnataka, India',
      description:
        'Built real-time communication features and scalable backend systems using AWS, GCP, Docker, Kubernetes, and WebRTC.',
      achievements: [
        'Solo-engineered a TypeScript-based, horizontally scalable analytics pipeline using MSK to process a billion plus monthly user events. Reduced latency from over 30 seconds to 200 milliseconds while cutting operational costs by 50%',
        'Integrated OpenTelemetry, implemented distributed tracing, and standardized logging. Developed a pipeline for processing logs and traces managing a billion plus records monthly. Designed dashboards for function timings and user actions insights',
        'Created a Playwright integration test suite that automates cross-browser testing, complemented by seamless integration with CI/CD pipelines and Slack notifications',
        'Wrote a custom solution using Cloudfront Functions having 20ms latency to replace ipInfo.io\'s avg 600ms latency integration',
        'Integrated 10+ third party solutions like Flagsmith, AWS Transcribe, Symbl, Intercom and so on',
        'Championed the conception, release, and iterative enhancement of the Electron SDK',
        'Created a foundational middleware logic with over 20+ active middlewares built atop it, widely utilized by clients',
      ],
      kudos: [
        {
          id: 'k5',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-ceo-webrtc.png',
          alt: 'CEO recognition for WebRTC work',
        },
        {
          id: 'k6',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-mayur-blog.png',
          alt: 'Recognition for blog contribution',
        },
        {
          id: 'k7',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-mayur-helpful.png',
          alt: 'Helpful team member recognition',
        },
        {
          id: 'k8',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-support-kudos.png',
          alt: 'Support team kudos',
        },
        {
          id: 'k9',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-support.png',
          alt: 'Customer support excellence',
        },
        {
          id: 'k10',
          imageUrl: 'https://assets.rathor.dev/kudos/dyte/dyte-team-work.png',
          alt: 'Team collaboration award',
        },
      ],
      links: [
        {
          label: 'Dyte.io',
          url: 'https://dyte.io',
        },
      ],
    },
    {
      id: '3',
      company: 'OmniPay / MyPay UK (Division of Datman)',
      title: 'Lead Full Stack Engineer',
      duration: 'Sep 2020 - Feb 2022',
      location: 'Bangalore, Karnataka, India',
      description: 'Led development of payment processing systems on AWS serverless architecture.',
      achievements: [
        'Expedited production deployments (DevOPS work) and technical portion of releases on AWS serverless architecture apart from mainstream coding and mentoring the team of 10+ on development tasks',
        'Introduced the CI/CD from scratch using Github actions, Amplify, Codebuild, Codepipeline, Serverless and Jest, Github pre-commit hooks and Husky to make the development faster and impeccable',
        'Constructed 40+ pipelines and codebuilds for 5+ projects to streamline the deployments along with Git Flow',
        'Integrated 10+ third parties, such as Stripe, Zoho, Address.io, CompanyHouse, and OpenCart',
      ],
      kudos: [
        {
          id: 'k11',
          imageUrl: 'https://assets.rathor.dev/kudos/mypay/mypay-aymen.png',
          alt: 'Recognition from Aymen',
        },
        {
          id: 'k12',
          imageUrl: 'https://assets.rathor.dev/kudos/mypay/mypay-joe.jpeg',
          alt: 'Recognition from Joe',
        },
        {
          id: 'k13',
          imageUrl: 'https://assets.rathor.dev/kudos/mypay/mypay-kailash.png',
          alt: 'Recognition from Kailash',
        },
      ],
      links: [
        {
          label: 'Datman',
          url: 'https://datman.je/',
        },
      ],
    },
    {
      id: '4',
      company: 'GLIDER.ai',
      title: 'Senior Full Stack Engineer',
      duration: 'Mar 2017 - Aug 2020',
      location: 'Bangalore, Karnataka, India',
      description: 'Led team development and built scalable assessment platform features.',
      achievements: [
        'Hired, Coached & Led a team of 5+ for over 2 years and for 7+ sub projects for GLIDER.ai',
        'Devised a WebRTC solution which improved video quality and reduced costs by $3000 a month',
        'Won 3 Major awards (Spot, Appreciation, Special Mention) and 1 competition in 3 years at GLIDER.ai',
        'Integrated 10+ third parties, such as Bullhorn, Greenhouse',
        'Developed a custom-made system to trace candidate activity/cheating using Tab Tracking, Face Detection (Pico.js), FFMPEG and WebRTC video recordings which could process 1 hour of video with 20 times better quality in less than 10 seconds',
        'Formed an entire system consisting of several EC2 servers using Leader Node - Compute Nodes paradigm running on CentOS/UBUNTU having S3, EFS, RabbitMQ to process, save and evaluate 10000+ candidates\' data a day',
        'Refined the plagiarism module (Python CGI scripts) to figure out the cheating 3 times faster with 90% accuracy',
      ],
      kudos: [
        {
          id: 'k16',
          imageUrl: 'https://assets.rathor.dev/kudos/glider/glider-manager.jpg',
          alt: 'Manager recognition',
        },
      ],
      links: [
        {
          label: 'GLIDER.ai',
          url: 'https://glider.ai',
        },
      ],
    },
  ],
  education: [
    {
      id: 'e1',
      institution: 'BKBIET Pilani',
      degree: 'Bachelor of Engineering',
      field: 'Computer Science',
      duration: 'Aug 2011 - May 2015',
      location: 'Pilani, Rajasthan, India',
    },
  ],
  skills: [
    // Cloudflare Ecosystem
    'Cloudflare Workers',
    'Cloudflare Pages',
    'Cloudflare R2',
    'Cloudflare D1',
    'Cloudflare KV',
    'Cloudflare Durable Objects',
    'Cloudflare Queues',
    'Cloudflare Workers Analytics',
    'Cloudflare RealtimeKit',
    'Realtime SFU',
    'Realtime TURN',
    
    // AWS Ecosystem
    'AWS API Gateway',
    'AWS Amplify',
    'AWS AppStream',
    'AWS Athena',
    'AWS Aurora',
    'AWS CloudFormation',
    'AWS CloudFront',
    'AWS CloudTrail',
    'AWS CloudWatch',
    'AWS CodeBuild',
    'AWS CodeCommit',
    'AWS CodeDeploy',
    'AWS CodePipeline',
    'AWS Cognito',
    'AWS Comprehend',
    'AWS Device Farm',
    'AWS DocumentDB',
    'AWS DynamoDB',
    'AWS EC2',
    'AWS ECS',
    'AWS EKS',
    'AWS EMR',
    'AWS Elastic Beanstalk',
    'AWS EventBridge',
    'AWS Glue',
    'AWS IAM',
    'AWS Kinesis',
    'AWS Lambda',
    'AWS MSK',
    'AWS Polly',
    'AWS RDS',
    'AWS Redshift',
    'AWS Route 53',
    'AWS S3',
    'AWS SNS',
    'AWS SQS',
    'AWS Step Functions',
    'AWS Transcribe',
    'AWS Translate',
    'AWS VPC',
    'AWS X-Ray',
    
    // GCP Ecosystem
    'GCP App Engine',
    'GCP Audit Logging',
    'GCP BigQuery',
    'GCP Bigtable',
    'GCP Build',
    'GCP CDN',
    'GCP Cloud Spanner',
    'GCP Compute Engine',
    'GCP DNS',
    'GCP Dataflow',
    'GCP Dataprep',
    'GCP Dataproc',
    'GCP Deployment Manager',
    'GCP Endpoints',
    'GCP Firebase',
    'GCP Firestore',
    'GCP Cloud Functions',
    'GCP GKE',
    'GCP IAM',
    'GCP Identity Platform',
    'GCP Looker Studio',
    'GCP Monitoring',
    'GCP Natural Language API',
    'GCP Pub/Sub',
    'GCP SQL',
    'GCP Source Repositories',
    'GCP Speech-to-Text',
    'GCP Cloud Storage',
    'GCP Text-to-Speech',
    'GCP Trace',
    'GCP Translation API',
    'GCP VPC',
    'GCP Workflows',
    'GCP Workspace',
    
    // Frontend
    'React.js',
    'Next.js',
    'TypeScript',
    'JavaScript ES6',
    'Redux',
    'React Hooks',
    'React Hook Forms',
    'Context API',
    'Material UI',
    'Chakra UI',
    'Elastic UI',
    'HTML5',
    'CSS3',
    'SCSS',
    'LESS',
    'Tailwind CSS',
    'Stencil',
    'WebComponents',
    
    // Backend
    'Node.js',
    'Express.js',
    'Meteor.js',
    'Moleculer.js',
    'GraphQL',
    'REST APIs',
    'WebRTC',
    'LibWebRTC',
    'MediaSoup',
    'Socket.io',
    'Serverless',
    'Spring MVC',
    'Maven',
    
    // Databases
    'PostgreSQL',
    'MySQL',
    'MongoDB',
    'Redis',
    'Redlock',
    'DynamoDB',
    'TypeORM',
    'Solr',
    
    // DevOps & Tools
    'Docker',
    'Kubernetes',
    'Terraform',
    'Ansible',
    'Helm',
    'Skaffold',
    'Ambassador',
    'Jenkins',
    'GitHub Actions',
    'GitLab CI',
    'Travis CI',
    'Git Flow',
    'Husky',
    'Commitizen',
    'Semantic-release',
    'PM2',
    'Grunt',
    'Gulp',
    'rollup.js',
    'VITE',
    
    // Monitoring & Observability
    'OpenTelemetry',
    'Grafana',
    'Prometheus',
    'New Relic',
    'LogRocket',
    'Jaeger',
    'Kibana',
    'PostHOG',
    'AWS IMDS',
    
    // Testing
    'Playwright',
    'Jest',
    'Integration Testing',
    
    // Other
    'System Design',
    'Distributed Systems',
    'Team Leadership',
    'Mentoring',
    'CI/CD',
    'WebAssembly',
    'FFMPEG',
    'Python',
    'Java',
    'Pico.js',
    'Backbone.js',
    'RabbitMQ',
    'Flagsmith',
    'i18n',
    'ESM',
    'CJS',
    'SSR',
    'OpenNext',
  ],
  certifications: [],
};
